var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile02Bolt = function SvgFile02Bolt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.334 7.332v4.667a2.667 2.667 0 0 1-2.667 2.666H5.334A2.667 2.667 0 0 1 2.667 12v-8a2.667 2.667 0 0 1 2.667-2.667h2m6 6v-.667A5.333 5.333 0 0 0 8 1.332h-.666m6 6a2 2 0 0 0-2-2h-.4c-.248 0-.372 0-.476-.016A1.333 1.333 0 0 1 9.35 4.207c-.016-.103-.016-.227-.016-.475v-.4a2 2 0 0 0-2-2M8 6.999 6.8 8.6c-.25.333-.374.5-.365.623a.333.333 0 0 0 .158.261c.106.065.311.03.721-.037l1.374-.23c.41-.068.615-.102.721-.037a.333.333 0 0 1 .159.26c.009.125-.116.291-.365.624L8 11.665"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile02Bolt);
export default ForwardRef;